import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@achra/ui/tooltip';
import { InfoIcon } from 'lucide-react';
import { UsdsIconWithInfo } from '@/modules/shared/components/svgs';
function UsdsTooltip() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-secondary-foreground size-12"><UsdsIconWithInfo className="size-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div data-slot="usds-tooltip-wrapper" className="flex h-full w-full items-center justify-center"><div className="relative">{t0}<Tooltip><TooltipTrigger asChild={true}><div data-slot="icon-wrapper" className={cn("absolute -bottom-1 left-6 flex cursor-pointer items-center justify-center rounded-full p-0.75", "bg-popover", "[&_path]:fill-secondary", "hover:[&_path]:fill-foreground")}><InfoIcon className="text-muted-foreground size-3.5 xl:size-4" /></div></TooltipTrigger><TooltipContent side="bottom" className="text-xs">All amounts are in USDS</TooltipContent></Tooltip></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { UsdsTooltip };